import { render, staticRenderFns } from "./ClientPaymentsTable.vue?vue&type=template&id=601530fe&scoped=true&"
import script from "./ClientPaymentsTable.vue?vue&type=script&lang=js&"
export * from "./ClientPaymentsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientPaymentsTable.vue?vue&type=style&index=0&id=601530fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601530fe",
  null
  
)

export default component.exports